import { Image } from 'antd';
import { Link } from 'react-router-dom';
import icon from '../img/404.png'

export const ErrorPage =() => {

    return (
  <div className='text-center'>
    <Image
    width={'45vh'}
    src={icon}
    className='my-4'
    preview={false}
  />
    <h1 className='customTextColor my-2'>Ups! Coś poszło nie tak</h1>
    <Link to='/home' className='button-65 my-3' >
        Powrót do strony głównej
    </Link>
  </div>
    )
}